import { useAgentReplyPreambleModel } from './useAgentReplyPreambleModel.js'
import AgentReplyPreambleView from './AgentReplyPreambleView.jsx'

export default function AgentReplyPreamble(props) {
  return <AgentReplyPreambleView {...props} {...useAgentReplyPreambleModel(props)} />
}
